<template>
  <div class="jifen-list" :style="{ height: clientHeight + 'px' }">
    <table class="list-box list-bg" v-if="JifenList.length > 0">
          <colgroup>
            <col width="500" />
            <col width="300" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>店铺</th>
              <th>积分</th>
              <th>操作</th>
            </tr>
          </thead>
    </table>

    <JifenItem v-for="(item, idx) in JifenList" :key="idx" :item="item"/>
    <NoList v-if="JifenList.length == 0" title="暂无积分记录" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import JifenItem from "../../components/jifen-item.vue";
import NoList from "../../components/no-list.vue";
export default {
  components: {
    JifenItem,
    NoList
  },
  computed: {
    ...mapGetters([
      "JifenList",
      "clientHeight"
    ])
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$store.dispatch("JIFENLIST");
    }
  }
}
</script>

<style>
.jifen-list {
  padding: 30px 20px 20px;
  width: 1140px;
  margin: auto;
  overflow-y: auto;
}

</style>
